// extracted by mini-css-extract-plugin
export default {"rating":"Rating_rating__8iP-2","rating-sm":"Rating_rating-sm__vy2TB"};